/**
 * Company legal suffixes to remove when generating workspace slugs
 * These are common business entity designations that should be stripped
 * to create cleaner, more user-friendly workspace identifiers
 */
export const COMPANY_SUFFIXES = [
  // US entities
  'Inc',
  'Inc.',
  'Incorporated',
  'LLC',
  'L.L.C.',
  'Corp',
  'Corp.',
  'Corporation',
  'Ltd',
  'Ltd.',
  'Limited',
  'Co',
  'Co.',
  'Company',
  'LLP',
  'L.L.P.',
  'LP',
  'L.P.',
  'PLLC',
  'P.L.L.C.',
  'PLC',
  'P.L.C.',

  // International entities
  'GmbH', // Germany
  'AG', // Germany/Switzerland
  'SA', // France/Spain/Latin America
  'SAS', // France
  'SARL', // France
  'SRL', // Italy/Romania
  'SpA', // Italy
  'BV', // Netherlands
  'NV', // Netherlands/Belgium
  'Pty', // Australia
  'Pty.', // Australia
  'AB', // Sweden
  'AS', // Norway/Denmark
  'OY', // Finland

  // Generic
  'Holdings',
  'Group',
  'Ventures',
] as const;

/**
 * Time savings metrics for Portfolio Operations Analyst
 * Used to calculate the value delivered by the AI employee
 */
export const TIME_SAVINGS = {
  /**
   * Estimated time saved per portfolio company per reporting period (in minutes)
   * Based on typical manual workflow:
   * - Email chase & follow-ups: 10-15 min
   * - Download & organize documents: 2-3 min
   * - Review & locate metrics: 5-10 min
   * - Extract & enter data: 10-20 min
   * - Cross-check & validate: 5-10 min
   * - Follow-up on missing data: 10-15 min
   * Total: ~60 minutes per company per period
   */
  MINUTES_PER_COMPANY_PER_PERIOD: 60,

  /**
   * Same as above, expressed in hours for easier display
   */
  HOURS_PER_COMPANY_PER_PERIOD: 1,
} as const;
